"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envVariablesValidator = void 0;
const tslib_1 = require("tslib");
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
const isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
const envVariablesValidator = (existingVariables, requiredVariables) => {
    const missingVariables = requiredVariables.reduce((acc, variable) => {
        if ((0, isNil_1.default)(existingVariables[variable])) {
            acc.push(variable);
        }
        return acc;
    }, []);
    if ((0, isEmpty_1.default)(missingVariables)) {
        return 'There are all required variables.';
    }
    throw `${missingVariables.join(', ')} ${missingVariables.length === 1 ? 'is' : 'are'} required!`;
};
exports.envVariablesValidator = envVariablesValidator;
